import {SagaIterator} from 'redux-saga';
import {all, call, put, putResolve, select} from 'redux-saga/effects';

import {ShippingMethodType} from 'types/shippingMethodsType';

import {setCheckoutLoading} from '../../../reducers/checkout/checkout';
import {saveShippingMethod} from '../../../reducers/deliveryStep/shippingMethods/shippingMethods';
import {getSelectedShippingMethod} from '../../../selectors/shippingMethods/shippingMethods';
import {saveCustomerAddressSaga} from '../saveCustomerAddressSaga/saveCustomerAddressSaga';

/**
 * Resave delivery & billing addresses, shipping method
 */
export function* resaveDeliverySaga(): SagaIterator {
    try {
        yield put(setCheckoutLoading(true));
        const selectedShipping: ShippingMethodType = yield select(getSelectedShippingMethod);
        yield all([
            yield call(saveCustomerAddressSaga),
            yield putResolve(saveShippingMethod(selectedShipping.code)),
        ]);
    } finally {
        yield put(setCheckoutLoading(false));
    }
}
